module.exports = __webpack_public_path__ + "static/media/exitoImg.7d1a555a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/exitoImg.png
// module id = 2028
// module chunks = 0